import log from 'salvo-lite/log'

class VatToggle {
    constructor (theme, elem) {
        this._elem = elem
        this._template = elem.dataset.vatToggle
        this._vatRate = elem.dataset.vatRate
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        const vatStatus = localStorage.getItem('vatStatus')
        const vatIncludeElems = document.querySelectorAll('.vat-inc')

        const rechargeApp = document.querySelector('.recharge-subscription-widget')

        vatIncludeElems.forEach((element) => {
            element.classList.add('hidden')
        })

        if (rechargeApp) {
            this._handleRechargeApp(rechargeApp)
        }

        if (vatStatus === 'vatInc') {
            this._loadState()
            document.body.classList.add('vat--included')
            document.body.classList.remove('vat--excluded')
        } else {
            document.body.classList.add('vat--excluded')
            document.body.classList.remove('vat--included')
        }
        this._handleClick()
    }

    _loadState () {
        const vatExcludeElems = document.querySelectorAll('.vat-exl')
        const vatIncludeElems = document.querySelectorAll('.vat-inc')

        this._elem.classList.toggle('toggle-switch--toggled')
        if (this._template === 'product') {
            this._updateProductPrices(vatExcludeElems, vatIncludeElems)
        }
    }

    _setState () {
        // Record clicked state
        const toggledStatus = this._elem.classList.contains('toggle-switch--toggled')
        if (toggledStatus) {
            localStorage.setItem('vatStatus', 'vatInc')
            document.body.classList.add('vat--included')
            document.body.classList.remove('vat--excluded')
        } else {
            localStorage.setItem('vatStatus', 'vatExc')
            document.body.classList.add('vat--excluded')
            document.body.classList.remove('vat--included')
        }
    }

    _handleClick () {
        const vatExcludeElems = document.querySelectorAll('.vat-exl')
        const vatIncludeElems = document.querySelectorAll('.vat-inc')

        this._elem.addEventListener('click', (e) => {
            e.target.classList.toggle('toggle-switch--toggled')
            if (this._template === 'product') {
                this._updateProductPrices(vatExcludeElems, vatIncludeElems)
            }
            this._setState()
        })
    }

    _updateProductPrices (vatExcludeElems, vatIncludeElems) {
        // toggles PDP prices
        vatIncludeElems.forEach((element) => {
            element.classList.toggle('hidden')
        })

        vatExcludeElems.forEach((element) => {
            element.classList.toggle('hidden')
        })
    }

    _convertPriceString (priceString) {
        // for converting price strings found in the recharge markup into an integer
        const numericString = priceString.replace(/[^\d.]/g, '')
        const price = parseFloat(numericString).toFixed(2)
        return price
    }

    _formaulateRechargeVatPrices (existingPrice) {
        // used to calculate the vat prices to be inserted into the recharge element on pdp pages
        const vatPrice = parseFloat((existingPrice / 100) * this._vatRate).toFixed(2)
        const newVatPrice = (Number(existingPrice) + Number(vatPrice)).toFixed(2)
        return newVatPrice
    }

    _handleRechargeMarkup (rechargeApp, observer) {
        const rechargeLabels = rechargeApp.querySelectorAll('.rc-radio__label')

        if (rechargeLabels.length !== 0) {
            observer.disconnect()
        }

        rechargeLabels.forEach((element) => {
            console.log(element)
            const priceElement = element.querySelector('.rc-radio__price')
            if (priceElement) {
                const existingPrice = this._convertPriceString(priceElement.innerHTML) // price without vat
                const newVatPrice = this._formaulateRechargeVatPrices(existingPrice)
                let clonedElement = priceElement.cloneNode(true) // cloned element to hold new vat price
                priceElement.innerHTML = priceElement.innerHTML + ' excl. vat' // add text to existing label
                priceElement.classList.add('vat-exl') // add exluding class to exisiting price after cloning element
                clonedElement.classList.add('vat-inc')
                clonedElement.innerHTML = ' £' + newVatPrice + ' incl.  vat'
                element.appendChild(clonedElement)
            } else {
                // extract price from label
                const labelContents = element.innerHTML
                const pricePattern = /[£$€]\d+(\.\d{1,2})?/
                const extractedPrice = labelContents.match(pricePattern) // Extracting  price using the pattern
                let existingPrice = 0
                if (extractedPrice && extractedPrice.length > 0) {
                    existingPrice = parseFloat(extractedPrice[0].replace(/[£$€]/g, '')).toFixed(2)
                }

                const newVatPrice = this._formaulateRechargeVatPrices(existingPrice)

                // clone element to hold new vat price
                let clonedElement = element.cloneNode(true)
                clonedElement.classList.add('vat-inc')
                clonedElement.innerHTML = 'One-time purchase £' + newVatPrice + ' incl. vat'

                element.innerHTML = labelContents + ' excl. vat' // add text to existing label
                element.classList.add('vat-exl') // add vat class to existing label
                element.parentNode.appendChild(clonedElement)
            }
        })
    }

    _handleRechargeApp (rechargeApp) {
        if (!rechargeApp.classList.contains('vat-config')) {
            const observer = new MutationObserver((mutationsList) => {
                this._handleRechargeMarkup(rechargeApp, observer)
            })

            const config = {
                childList: true,
                subtree: true
            }

            observer.observe(rechargeApp, config)

            rechargeApp.classList.add('vat-config')
        }
    }
}

export default VatToggle



// WEBPACK FOOTER //
// ./src/resources/scripts/components/VatToggle.js